import GameForeground from './GameForeground';

export default GameForeground;
